
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Register from "../Pages/Auth/Register";
import Profile from "../Pages/Profile/Profile";
import Content from "../Pages/Profile/Content";
import EditProfile from "../Pages/Profile/EditProfile";
import OrderDetails from "../Pages/Home/OrderDetails";
import Orders from "../Pages/Home/Orders";



const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 100,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 1,
        path: "/returned-orders",
        component: <Orders />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/register",
        component: <Register />,
    },
    {
        pageId : 5,
        path: "/profile",
        component: <Profile />,
    },
    {
        pageId : 6,
        path: "/contents/:slug",
        component: <Content />,
    },
    {
        pageId : 7,
        path: "/edit-profile",
        component: <EditProfile />,
    },
    {
        pageId : 7,
        path: "/returned-orders/:id",
        component: <OrderDetails />,
    },
];
export default appRoutes;
